import { Routes, Route } from 'react-router-dom';

import { DashboardLayout } from '@/layouts/DashboardLayout';
import { AuthLayout } from '@/layouts/AuthLayout';
import { ProtectedRoute } from '@/components/common/ProtectedRoute';
import { AdminRoute } from '@/components/common/AdminRoute';

import { LoginPage } from '@/pages/auth/LoginPage';
import { RegisterPage } from '@/pages/auth/RegisterPage';
import { DashboardPage } from '@/pages/dashboard/DashboardPage';
// import { UsersPage } from '@/pages/users/UsersPage';
import { OnboardingPage } from '@/pages/onboarding/OnboardingPage';
import { ProfilePage } from '@/pages/ProfilePage';
import { ReportsPage } from '@/pages/user/ReportsPage';
import { SettingsPage } from '@/pages/settings/SettingsPage';
import { SimpleFormPage } from '@/pages/SimpleFormPage';
// import { ComprehensiveFormPage } from '@/pages/ComprehensiveFormPage';
import { NotFoundPage } from '@/pages/NotFoundPage';
import { Navigate } from 'react-router-dom';
import { UserDetailsPage } from '@/pages/users/UserDetailsPage';
import TransitsTable from './pages/users/UserTransitPage';

import { PredictionsPage } from './pages/users/PredictionPage';
import Prediction from './pages/user/components/GeneralPredictions';
import MessageTable from './pages/user/components/Message List';
import FeedbacksPage from './pages/user/FeedbacksPage';
import { DeleteUserPage } from '@/pages/admin/DeleteUserPage';
import { DeleteUsersPage } from '@/pages/admin/DeleteUsersPage';
import { SyncPredictionPage } from '@/pages/admin/SyncPredictionPage';
import VideoGenerationsPage from '@/pages/admin/VideoGenerationsPage';
import S3VideosPage from '@/pages/admin/S3VideosPage';
import GenerateAudioPage from '@/pages/admin/GenerateAudioPage';

export function App() {
  return (
    <Routes>
      {/* Auth Routes */}
      <Route element={<AuthLayout />}>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />
      </Route>

      {/* Protected Routes */}
      <Route element={<ProtectedRoute />}>
        <Route element={<DashboardLayout />}>
          <Route path="/" element={<Navigate to="/users" replace />} />
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/profile" element={<ProfilePage />} />
          <Route path="/onboarding" element={<OnboardingPage />} />

          {/* Analytics Routes */}

          <Route path="/analytics/reports" element={<Navigate to="/users" replace />} />
          <Route path="/users" element={<ReportsPage />} />
          <Route path="/users/details" element={<UserDetailsPage />} />
          <Route path="/transit-tables" element={<TransitsTable />} />
          <Route path="/predictions-prompt-data" element={<PredictionsPage />} />
          <Route path="/Predictions" element={<Prediction />} />
          <Route path="/waiting-list" element={<MessageTable />} />
          <Route path="/feedbacks" element={<FeedbacksPage />} />
          <Route path="/sync-prediction" element={<SyncPredictionPage />} />
          <Route path="/generate-audio" element={<GenerateAudioPage />} />
          <Route path="/s3-video-uploads" element={<VideoGenerationsPage />} />
          <Route path="/s3-videos" element={<S3VideosPage />} />

          {/* Settings Routes */}
          <Route path="/settings" element={<SettingsPage />} />

          {/* Form Examples */}
          <Route path="/forms" element={<SimpleFormPage />} />
          {/* <Route path="/forms/comprehensive" element={<ComprehensiveFormPage />} /> */}

          {/* Admin Routes */}
          <Route element={<AdminRoute />}>
            {/* <Route path="/users" element={<UsersPage />} /> */}
          </Route>
        </Route>
      </Route>

      {/* Admin utility — URL only, no sidebar */}
      <Route element={<ProtectedRoute />}>
        <Route path="/admin/delete-user" element={<DeleteUserPage />} />
        <Route path="/admin/delete-users" element={<DeleteUsersPage />} />
      </Route>

      {/* 404 */}
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}
